import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import { LanguageProvider } from "./context/LanguageContext";

/* ===== PUBLIC PAGES ===== */
import Mhero1 from "./pages/MHERO1/Mhero1";
import Mhero2 from "./pages/MHERO2/Mhero2";
import VoyahFree from "./pages/VoyahFree/VoyahFree";
import Login from "./components/pages/Login/Login";
import ProtectedRoute from "./routes/ProtectedRoute";
import DashboardLayout from "./components/pages/Dashboard/DashboardLayout";
import Dashboard from "./components/pages/Dashboard/Dashboard";

import VoyahDream from "./pages/VoyahDream/VoyahDream";
import VoyahTaishan from "./pages/VoyahTaishan/VoyahTaishan";
import ContentPage from "./components/pages/Dashboard/Models/ContentPage";
import Home from "./components/pages/Home/Home";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import AppLoader from "./components/AppLoader/AppLoader";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AppLoader />
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/mhero1" element={<Mhero1 />} />
          <Route path="/mhero2" element={<Mhero2 />} />
          <Route path="/voyahfree" element={<VoyahFree />} />
          <Route path="/voyahdream" element={<VoyahDream />} />
          <Route path="/voyahtaishan" element={<VoyahTaishan />} />
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute allowedRoles={["Admin"]} />}>
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Dashboard />} />

              <Route path="contentpage" element={<ContentPage />} />
            </Route>
          </Route>

        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
